<app-bar-chart
  [labels]="labels"
  [series]="series"
  [loading]="isLoading"
  [title]="'Average Events per Session'"
  [chartType]="'line'"
  [options]="options"
></app-bar-chart>
